import React, { useEffect, useRef } from 'react';

// Componente que renderiza el badge de calificación de Google Customer Reviews
// Útil para mostrar el consolidado de reseñas del comercio
const GcrRatingBadge = ({ className = '' }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        const merchantId = parseInt(process.env.REACT_APP_GCR_MERCHANT_ID || '0', 10);
        if (!merchantId) return;

        const ensurePlatformScript = () => {
            return new Promise((resolve) => {
                if (window.__gcrPlatformLoaded) return resolve(true);
                const existing = document.querySelector('script[src*="apis.google.com/js/platform.js"]');
                if (existing) {
                    window.__gcrPlatformLoaded = true;
                    return resolve(true);
                }
                const s = document.createElement('script');
                s.src = 'https://apis.google.com/js/platform.js?onload=renderBadge';
                s.async = true;
                s.defer = true;
                document.body.appendChild(s);
                window.renderBadge = () => resolve(true);
            });
        };

        const renderBadge = () => {
            try {
                if (!window.gapi || !containerRef.current) return;
                window.gapi.load('ratingbadge', function () {
                    try {
                        window.gapi.ratingbadge.render(containerRef.current, { merchant_id: merchantId });
                    } catch (e) {
                        // evitar romper la UI si falla
                    }
                });
            } catch (e) {
                // ignore
            }
        };

        ensurePlatformScript().then(renderBadge);
    }, []);

    return (
        <div ref={containerRef} className={className}></div>
    );
};

export default GcrRatingBadge;

